module.exports = "./img/a9fdee44b285a0ae7908497f01c416a8.jpg";